import API from './API.js';
import axios from 'axios'

export default class Categories extends API {
  constructor() {
    super('Library/categories');
  }
  async GetAllTree(params) {
    // console.log("api", params);
    const response = await axios.get(`/${this.route}`, { params })
    let { data } = response
    if (params) data = response.data.data;
    if (this.imageFileds) this.addImagePath(data, this.imageFileds)

    return this.listToTree(response.data)
  }

  listToTree(list) {
    list = list.map(obj => {
      return { text: obj.name, id: obj.id, parent_id: obj.parent_id }
    })
    var map = {}, node, roots = [], i;



    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parent_id !== 0) {
        var parent = list.find(a => a.id == node.parent_id);
        if (!parent.children) parent.children = [];
        parent.children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
}
